import Link from "next/link";
import { usePath } from "../contexts/PathContext";

export default function TaskList({ events }) {
  const { isMerchantPage } = usePath();
  return (
    <ul className="grid justify-center ">
      {events.map((event) => (
        <li
          key={event.id}
          className={`w-[150px] ${
            isMerchantPage
              ? "hover:bg-[var(--color-bg-blue)]"
              : "hover:bg-[var(--color-bg-orange)]"
          } `}
        >
          <Link href={event.url} className="block px-4 py-4 text-center">
            {event.name}
          </Link>
        </li>
      ))}
    </ul>
  );
}
